import { jsx as _jsx } from "react/jsx-runtime";
import { useAppTranslations } from '../hooks/useAppTranslations';
import { buildContext } from './buildContext';
export const [useGuidaTranslationContext, GuidaTranslationContextProvider] = buildContext();
/** Common translation provider for all GUIDA apps. Will include kompis and GUIDA common translations by default. */
export const GuidaTranslationProvider = ({ children, appName, locale }) => {
    const translations = useAppTranslations(appName, locale);
    if (!translations) {
        return null;
    }
    return (_jsx(GuidaTranslationContextProvider, { value: { translations }, children: children }));
};
//# sourceMappingURL=translations.js.map